// eslint-disable-next-line
export const makeUserApiEndpoints = (userId = ":userId") => {
  const endpoints = {
    userItem: (id = "") => `/users/${id || userId}`,
    userInfo: () => `/auth/userinfo`,
    userNotificationSettings: (id = "") => `/users/${id || userId}/notification-settings`,
  }
  return endpoints
}
